// src/hooks/useCanSee.js
// Stessa identica logica di controllo sezioni già usata in Sidebar.js — estratta qui per
// essere riusabile anche fuori dalla Sidebar (es. Mia Area), senza duplicare/reinventare
// un sistema di permessi che va tenuto in un solo posto.
//
// MODELLO CORRETTO (prima era sbagliato): il ruolo dà la base — configurata in Abilitazioni,
// o i default sensati per ruolo se il titolare non ha ancora configurato nulla. Le aggiunte
// per singola persona si SOMMANO a quella base, le rimozioni per singola persona si
// SOTTRAGGONO — mai più "o ruolo o lista personalizzata", che faceva perdere tutti i
// permessi normali del ruolo appena si aggiungeva anche un solo permesso extra a qualcuno.
import { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { useOrg } from "../contexts/OrgContext";
import { sezioniUtente } from "../utils/permessiEffettivi";

export function useCanSee() {
  const { currentUser, userProfile, isPlatformOwner, isOrgAdmin } = useAuth();
  const { effectiveOrgId } = useOrg();
  const [sezioniAbilitate, setSezioniAbilitate] = useState(null);

  useEffect(() => {
    if (!effectiveOrgId || isPlatformOwner || isOrgAdmin) return;
    return onSnapshot(doc(db, "abilitazioniSezioni", effectiveOrgId), snap => {
      const data = snap.exists() ? snap.data() : {};
      // ruolo + aggiunte − rimozioni, con i default dei permessi nati dopo il salvataggio (W417)
      setSezioniAbilitate(sezioniUtente(data, { ruolo: userProfile?.ruoloOperativo, uid: currentUser?.uid }));
    });
  }, [effectiveOrgId, isPlatformOwner, isOrgAdmin, userProfile, currentUser]);

  const canSee = (sezId) => {
    if (isPlatformOwner || isOrgAdmin) return true;
    if (sezioniAbilitate === null) return true; // ancora in caricamento, non blocca
    return sezioniAbilitate.has(sezId);
  };

  return canSee;
}

// Come useCanSee, ma per decidere QUALI DATI leggere: mentre i permessi si caricano
// restituisce null (non «sì»), così chi non ha il permesso non lancia una lettura che le
// regole rifiuterebbero. Stessa logica: base del ruolo + aggiunte − rimozioni per persona.
export function useHaSezione(sezId) {
  const { currentUser, userProfile, isPlatformOwner, isOrgAdmin } = useAuth();
  const { effectiveOrgId } = useOrg();
  const [ha, setHa] = useState(null);
  const tutto = isPlatformOwner || isOrgAdmin;

  useEffect(() => {
    if (tutto) { setHa(true); return; }
    if (!effectiveOrgId || !userProfile) { setHa(null); return; }
    return onSnapshot(doc(db, "abilitazioniSezioni", effectiveOrgId), snap => {
      const data = snap.exists() ? snap.data() : {};
      setHa(sezioniUtente(data, { ruolo: userProfile?.ruoloOperativo, uid: currentUser?.uid }).has(sezId));
    }, () => setHa(false));
  }, [effectiveOrgId, tutto, userProfile, currentUser, sezId]);

  return tutto ? true : ha;
}

/**
 * Richieste di fatturazione: true = le vede tutte (titolare, admin, chi ha «da-fatturare»),
 * false = solo le proprie (PM), null = permessi in caricamento. Firestore rules 57.
 */
export const useVedeTutteFatturazioni = () => useHaSezione("da-fatturare");

